import type { AnimeNews } from "@/types";

export const animeNews: AnimeNews[] = [
  {
    id: "star-frost-s2-announced",
    title: "《星霜少女》第二季正式定档，白羽雪乃新造型曝光",
    category: "新闻",
    date: "2026-10-08",
    author: "编辑部·小葵",
    thumbnail: "https://readdy.ai/api/search-image?query=anime%20promotional%20key%20visual%20of%20silver%20haired%20girl%20in%20snow%20scene%2C%20pastel%20pink%20and%20white%20palette%2C%20anime%20illustration%20poster%20style%2C%20high%20detail&width=800&height=500&seq=news-thumb-01&orientation=landscape",
    summary: "官方于昨日公布《星霜少女》第二季将于明年一月开播，并首次公开白羽雪乃的冬装新造型与制作阵容。",
    content: [
      "备受期待的《星霜少女》第二季终于有了确切消息。官方在最新一期的制作发表会上宣布，第二季将于明年一月正式开播，全季共 12 话。",
      "本次最受关注的，是白羽雪乃的全新角色设定。与第一季清冷的白色和服不同，新造型加入了更柔和的粉色调披风，象征她在旅途中逐渐打开的心扉。角色设计负责人表示：「我们希望用颜色的变化，去呈现雪乃内心的成长。」",
      "制作阵容方面，第一季的核心团队悉数回归，同时新增了两位资深原画师。音乐依旧由知名作曲家担纲，片头曲则邀请到人气歌姬演唱。",
      "此外，官方还放出了一段 30 秒的先导 PV，画面中雪乃独自站在冰原之上，身后是缓缓升起的极光。短短数小时，该 PV 便突破了百万播放量，粉丝们纷纷在评论区留言「等这一刻等太久了」。"
    ],
    views: 48210,
    popularity: 98,
    tags: ["新番", "定档", "角色设定"]
  },
  {
    id: "forest-magic-review",
    title: "深度评论：《森之魔法语》凭什么成为年度治愈天花板",
    category: "评论",
    date: "2026-10-05",
    author: "特约评论员·林川",
    thumbnail: "https://readdy.ai/api/search-image?query=anime%20enchanted%20forest%20scene%20with%20pink%20haired%20magical%20girl%2C%20pastel%20green%20and%20pink%20palette%2C%20anime%20illustration%20style%2C%20high%20detail&width=800&height=500&seq=news-thumb-02&orientation=landscape",
    summary: "一部没有反派、没有大战的作品，却让无数观众在深夜红了眼眶。我们来聊聊《森之魔法语》的治愈方法论。",
    content: [
      "在如今这个「每集都要有爆点」的时代，《森之魔法语》显得格外异类。它没有热血的战斗，没有跌宕的反转，只有一个个发生在森林里的小小故事。",
      "但正是这种「慢」，成为了它最大的力量。见习魔女桃濑小铃每一次念错的咒语，其实都是在告诉我们：笨拙的真诚，比完美的技巧更动人。",
      "作品对「治愈」的理解，不是强行让你开心，而是允许你难过。有一集里，小铃陪着失落的精灵静静地看了一整夜的星星，没有一句安慰的台词，却让无数观众破防。",
      "如果说第一季是治愈，那么即将到来的新篇或许会带来更多关于告别的思考。无论如何，这部作品已经证明：温柔本身，就是一种强大的叙事。"
    ],
    views: 35680,
    popularity: 92,
    tags: ["评论", "治愈", "深度解析"]
  },
  {
    id: "sky-dorm-special",
    title: "专题：走进《天空寮的日常》的云端世界观设定",
    category: "专题",
    date: "2026-09-30",
    author: "专题组·青羽",
    thumbnail: "https://readdy.ai/api/search-image?query=anime%20floating%20cloud%20dormitory%20building%20with%20girls%2C%20bright%20pastel%20sky%20palette%2C%20anime%20illustration%20concept%20art%2C%20high%20detail&width=800&height=500&seq=news-thumb-03&orientation=landscape",
    summary: "漂浮在云端的学生宿舍究竟是如何运转的？本专题带你拆解《天空寮的日常》中那些藏在细节里的世界观设定。",
    content: [
      "《天空寮的日常》最迷人的地方，是它构建了一个看似童话、实则逻辑严密的世界。漂浮宿舍「天空寮」并非魔法产物，而是依托一种名为「云核」的古老能量装置维持浮空。",
      "宿舍分为东西两翼，东翼住着高年级生，西翼则是新生的天地。星野爱丽丝所在的顶楼天台，正是全宿舍唯一可以直连云核的地方，也是她「收集星星」的秘密基地。",
      "值得一提的是，作品里的每一片云都有名字。制作组表示，这是为了强调「即使是最轻盈的存在，也值得被认真对待」这一核心理念。",
      "随着剧情推进，天空寮逐渐显露出它更深层的秘密——它其实是一艘沉睡的方舟。这个反转，让整部作品的格局瞬间被打开。"
    ],
    views: 29840,
    popularity: 88,
    tags: ["专题", "世界观", "设定集"]
  },
  {
    id: "phantom-academy-manga",
    title: "《幻夜学园》漫画版迎来最终话，黑羽夜结局引热议",
    category: "新闻",
    date: "2026-09-26",
    author: "编辑部·小葵",
    thumbnail: "https://readdy.ai/api/search-image?query=anime%20dark%20fantasy%20academy%20with%20black%20haired%20girl%20night%20scene%2C%20purple%20pastel%20palette%2C%20anime%20illustration%20style%2C%20high%20detail&width=800&height=500&seq=news-thumb-04&orientation=landscape",
    summary: "连载六年的《幻夜学园》漫画版正式完结，黑羽夜的最终归宿引发粉丝激烈讨论，官方暗示或将推出外传。",
    content: [
      "随着最新一期杂志的发售，《幻夜学园》漫画版迎来了它的最终话。这部陪伴读者六年的作品，以一个留白的结局收尾，立刻在社交媒体上引发了两极分化的讨论。",
      "争议的焦点集中在黑羽夜的结局上。有人认为她的牺牲成就了主题的升华，也有人觉得这份「意难平」太过残忍。",
      "作者在完结感言中写道：「夜从不是需要被拯救的人，她只是需要一个愿意并肩的人。这个结局，是我能给她的最诚实的温柔。」",
      "官方同时放出消息，正在考虑推出一部以外传形式连载的新作品，主角人选尚未公布，但不排除继续围绕夜的故事展开。"
    ],
    views: 41120,
    popularity: 94,
    tags: ["漫画", "完结", "热议"]
  },
  {
    id: "flame-girl-broadcast",
    title: "《烈焰少女》舞台剧开启巡演，火野炎角色票选引爆社交媒体",
    category: "新闻",
    date: "2026-09-21",
    author: "编辑部·小炎",
    thumbnail: "https://readdy.ai/api/search-image?query=anime%20stage%20performance%20poster%20with%20red%20haired%20energetic%20girl%2C%20warm%20pastel%20orange%20palette%2C%20anime%20illustration%20style%2C%20high%20detail&width=800&height=500&seq=news-thumb-05&orientation=landscape",
    summary: "《烈焰少女》舞台剧将于下月开启全国巡演，官方开放的角色票选活动短短三天便收到超过十万张投票。",
    content: [
      "《烈焰少女》的舞台剧化消息一经公布，便点燃了整个粉丝圈。官方同步开启的「你心中的火野炎」角色票选活动，三天内投票数突破十万。",
      "本次舞台剧将采用全新的多媒体舞台技术，把作品中的「火焰」以投影与实景结合的方式呈现，力求还原动画里那种炽热的冲击感。",
      "导演在接受采访时透露，舞台剧会特别加强火野炎与伙伴之间的羁绊描写，「我们想让大家看到，她的强大从来不是一个人的强大」。",
      "巡演将于下月从东京首演，随后前往大阪、名古屋等城市，门票将于本周五开启预售。"
    ],
    views: 26730,
    popularity: 85,
    tags: ["舞台剧", "巡演", "活动"]
  },
  {
    id: "moon-lily-art",
    title: "专题：《月下铃兰》美术风格全解析，一场东方美学的胜利",
    category: "专题",
    date: "2026-09-18",
    author: "专题组·青羽",
    thumbnail: "https://readdy.ai/api/search-image?query=moonlit%20traditional%20japanese%20garden%20with%20lavender%20haired%20girl%2C%20purple%20pastel%20palette%2C%20anime%20illustration%20art%20style%2C%20high%20detail&width=800&height=500&seq=news-thumb-06&orientation=landscape",
    summary: "从配色到构图，《月下铃兰》把东方古典美学做到了极致。本期专题带你逐帧解读这部作品的美术密码。",
    content: [
      "《月下铃兰》几乎每一帧都可以截下来当壁纸。它的美术风格之所以如此动人，核心在于对「留白」的极致运用。",
      "作品大量使用了垂直线构图，无论是帘幕、雨丝还是月光，都在引导视线向上延伸，营造出空灵而肃穆的氛围。",
      "配色上，制作组刻意压低了饱和度，以月白色与铃兰紫为主调，让整部作品笼罩在一层薄薄的、朦胧的辉光之中。",
      "月见铃兰的每一次起舞，都是全片美术表现力的巅峰。慢镜头下的和服褶皱、飘落的花瓣、月光的折射，构成了一场无声的视觉诗篇。"
    ],
    views: 22310,
    popularity: 80,
    tags: ["专题", "美术", "东方美学"]
  },
  {
    id: "mint-soda-film",
    title: "《薄荷气泡水》宣布剧场版制作决定，夏日记忆再续",
    category: "新闻",
    date: "2026-09-12",
    author: "编辑部·小葵",
    thumbnail: "https://readdy.ai/api/search-image?query=seaside%20summer%20scene%20with%20mint%20haired%20girl%20holding%20soda%2C%20cool%20pastel%20blue%20palette%2C%20anime%20illustration%20style%2C%20high%20detail&width=800&height=500&seq=news-thumb-07&orientation=landscape",
    summary: "官方宣布《薄荷气泡水》剧场版制作决定，将讲述本篇之后主角们各自成长的新篇章。",
    content: [
      "在粉丝们长久的呼唤下，《薄荷气泡水》终于迎来了剧场版制作决定。这次的舞台将移到一个遥远的南方海岛。",
      "苍井薄荷的声优在活动上表示：「接到这个消息时我真的哭了，我也想再看看薄荷现在的样子。」",
      "剧场版将聚焦「成长后的重逢」这一主题，当年一起看海的少女们，将以怎样的姿态再次相聚，成为最大看点。",
      "官方预计明年夏季上映，更多详情将在后续陆续公开。"
    ],
    views: 31250,
    popularity: 87,
    tags: ["剧场版", "制作决定", "新篇"]
  },
  {
    id: "mimi-snow-ball",
    title: "《喵星少女》联动活动开启，小猫咪咪限定周边秒售罄",
    category: "新闻",
    date: "2026-09-08",
    author: "编辑部·小喵",
    thumbnail: "https://readdy.ai/api/search-image?query=cute%20cat%20girl%20anime%20merchandise%20display%20in%20store%2C%20playful%20pastel%20peach%20palette%2C%20anime%20illustration%20style%2C%20high%20detail&width=800&height=500&seq=news-thumb-08&orientation=landscape",
    summary: "《喵星少女》与知名甜品品牌的联动活动正式上线，小猫咪咪限定周边在上线十分钟内即被抢购一空。",
    content: [
      "本次联动以「猫咪的下午茶」为主题，推出了限定甜品与一系列周边商品，涵盖毛绒玩偶、马克杯与文件夹等。",
      "其中最受欢迎的小猫咪咪限定玩偶，在官方商城上线仅十分钟便宣告售罄，二手平台上的价格一度翻了三倍。",
      "线下联动咖啡厅也同步开业，店内的猫咪造型甜点迅速成为社交媒体上的打卡热点。",
      "官方表示，会根据本次反响考虑追加生产，同时也预告了下一波联动企划即将启动。"
    ],
    views: 19870,
    popularity: 76,
    tags: ["联动", "周边", "活动"]
  },
  {
    id: "tsuyu-summer-theme",
    title: "评论：《时雨之夏》如何把「傲娇」写成了梅雨季的浪漫",
    category: "评论",
    date: "2026-09-03",
    author: "特约评论员·林川",
    thumbnail: "https://readdy.ai/api/search-image?query=rainy%20anime%20scene%20with%20black%20haired%20girl%20holding%20umbrella%2C%20moody%20pastel%20blue%20palette%2C%20anime%20illustration%20style%2C%20high%20detail&width=800&height=500&seq=news-thumb-09&orientation=landscape",
    summary: "时雨铃大概是近年最讨人喜欢的傲娇角色。这篇文章想知道，为什么「口是心非」反而更让人心动。",
    content: [
      "傲娇是一个被用烂的设定，但《时雨之夏》却让它重新焕发了光彩。答案藏在细节里：时雨铃永远只带一把伞。",
      "作品从不直接告诉观众她的心意，而是通过一个个微小动作去暗示——伞往哪边偏，雨天里谁先到操场，谁的书桌里多了颗糖。",
      "这种「克制的表达」，恰恰是傲娇最动人的地方。她的每一句「才不是因为你」，其实都是「其实就是因为你」。",
      "《时雨之夏》证明了，最浪漫的告白从来不是直白的情话，而是那些藏在梅雨季里、迟迟不肯说出口的心事。"
    ],
    views: 18420,
    popularity: 74,
    tags: ["评论", "傲娇", "情感"]
  },
  {
    id: "yukino-borne-poll",
    title: "年度萝莉角色人气票选结果出炉，白羽雪乃蝉联冠军",
    category: "新闻",
    date: "2026-08-28",
    author: "编辑部·小葵",
    thumbnail: "https://readdy.ai/api/search-image?query=anime%20character%20popularity%20contest%20poster%20with%20silver%20haired%20girl%20winning%2C%20festive%20pastel%20pink%20palette%2C%20anime%20illustration%20style%2C%20high%20detail&width=800&height=500&seq=news-thumb-10&orientation=landscape",
    summary: "由本主题站发起的年度人气票选活动正式落幕，白羽雪乃成功卫冕，桃濑小铃与星野爱丽丝紧随其后。",
    content: [
      "历时一个月的年度人气票选活动圆满结束，总投票数突破五十万，创下历史新高。",
      "最终，白羽雪乃以绝对优势蝉联冠军。评委表示，她身上那种「沉默的温柔」打动了各个年龄层的观众。",
      "亚军桃濑小铃与季军星野爱丽丝的票数十分接近，粉丝们在评论区展开了热烈的讨论。",
      "本次票选还特别设立了「最佳新人」奖项，由小猫咪咪获得。明年，本主题站将继续举办这一活动，敬请期待。"
    ],
    views: 52810,
    popularity: 96,
    tags: ["票选", "人气", "活动"]
  }
];